import React from 'react';
import Input from '../../../components/ui/Input';
import {
  maskBrlCurrencyDisplay,
  normalizeBrlCurrencyInput,
  maskDecimalBrDisplay,
  normalizeDecimalBrInput,
} from '../../../utils/masks';
import { maskDateBrDisplay, normalizeDateBrInput } from '../../../utils/dateBr';

function maskValueForType(type, raw) {
  if (type === 'currency') return maskBrlCurrencyDisplay(raw);
  if (type === 'number') return maskDecimalBrDisplay(raw);
  if (type === 'date') return maskDateBrDisplay(raw);
  return raw ?? '';
}

function normalizeValueForType(type, input) {
  if (type === 'currency') return normalizeBrlCurrencyInput(input);
  if (type === 'number') return normalizeDecimalBrInput(input);
  if (type === 'date') return normalizeDateBrInput(input);
  return input;
}

const PersonalizedContractForm = ({
  fields,
  formData,
  setFormData,
  errors = {},
  onFieldFocus,
  onFieldBlur,
}) => {
  if (!fields?.length) {
    return (
      <p className="text-sm text-muted-foreground rounded-lg border border-dashed border-border p-4">
        Selecione um modelo personalizado para exibir os campos do formulário.
      </p>
    );
  }

  const handleChange = (field, rawInput) => {
    const value = normalizeValueForType(field.type, rawInput);
    setFormData((prev) => ({ ...prev, [field.id]: value }));
  };

  return (
    <div className="space-y-4">
      <h2 className="text-lg font-heading font-semibold text-foreground">
        Dados do documento
      </h2>
      {fields.map((field) => {
        const rawValue = formData[field.id] ?? '';
        const displayValue =
          field.type === 'currency' ||
          field.type === 'number' ||
          field.type === 'date'
            ? maskValueForType(field.type, rawValue)
            : rawValue;

        const commonProps = {
          id: field.id,
          label: `${field.label}:`,
          required: field.required,
          error: errors[field.id],
          value: displayValue,
          onFocus: () => onFieldFocus?.(field.id),
          onBlur: onFieldBlur,
        };

        if (field.type === 'date') {
          return (
            <Input
              key={field.id}
              {...commonProps}
              type="text"
              inputMode="numeric"
              placeholder="dd/mm/aaaa"
              maxLength={10}
              onChange={(e) => handleChange(field, e.target.value)}
            />
          );
        }

        if (field.type === 'number') {
          return (
            <Input
              key={field.id}
              {...commonProps}
              type="text"
              inputMode="decimal"
              onChange={(e) => handleChange(field, e.target.value)}
            />
          );
        }

        if (field.type === 'currency') {
          return (
            <Input
              key={field.id}
              {...commonProps}
              type="text"
              inputMode="decimal"
              placeholder="R$ 0,00"
              onChange={(e) => handleChange(field, e.target.value)}
            />
          );
        }

        return (
          <Input
            key={field.id}
            {...commonProps}
            type="text"
            onChange={(e) => handleChange(field, e.target.value)}
          />
        );
      })}
    </div>
  );
};

export default PersonalizedContractForm;
